import SocialList from 'components/ui/Footer/SocialList';
import './Footer.scss';

const ENAMAD_URL =
  'https://trustseal.enamad.ir/?id=7649131&Code=hz3JTp9EQvHtRqenX25VRm3NDsxBkoOp';
const ENAMAD_LOGO =
  'https://trustseal.enamad.ir/logo.aspx?id=7649131&Code=hz3JTp9EQvHtRqenX25VRm3NDsxBkoOp';

export const Footer = () => {
  return (
    <div className="footer">
      <SocialList />
      {/* eNamad needs the referrer to verify the seal, so noreferrer can't be used */}
      {/* eslint-disable-next-line react/jsx-no-target-blank */}
      <a
        className="footer__enamad"
        referrerPolicy="origin"
        target="_blank"
        rel="noopener"
        href={ENAMAD_URL}
      >
        <img
          referrerPolicy="origin"
          src={ENAMAD_LOGO}
          alt=""
          style={{ cursor: 'pointer' }}
          {...{ code: 'hz3JTp9EQvHtRqenX25VRm3NDsxBkoOp' }}
        />
      </a>
      <p>© اپلیکیشن سلامت ‌فول برای سلامت ذهن و بدن</p>
    </div>
  );
};
